<div class="navbar">
  <div class="contenedor">
    <div class="logo">
      <img src="assets/img/logo/aurodoc@3x.png" alt="AuroDoc" *ngIf="!isMobile || (isLoggedIn$ | async)" />
      <img
        src="assets/img/logo/aurodoc-mini@3x.png"
        alt="AuroDoc"
        *ngIf="
          isMobile &&
          ((isLoggedIn$ | async) === false || (isLoggedIn$ | async) === null || (isLoggedIn$ | async) === undefined)
        "
      />
    </div>
    <nav>
      <div class="collapse-menu"><i class="fa fa-bars" aria-hidden="true"></i></div>
      <ul class="main-menu">
        <li class="nav__item" routerLinkActive="active">
          <a href="#pasos-crear-documento">{{ 'HOME.HOME' | translate }}</a>
        </li>
        <li class="nav__item" routerLinkActive="active">
          <a href="#quienes-somos">{{ 'HOME.ABOUT US' | translate }}</a>
        </li>
        <li class="nav__item" routerLinkActive="active">
          <a href="#nuestros-retos">{{ 'HOME.OUR CHALLENGES' | translate }}</a>
        </li>
        <li class="nav__item" routerLinkActive="active">
          <a href="#contactanos">{{ 'HOME.CONTACT US' | translate }}</a>
        </li>
        <li class="nav__item-button" routerLinkActive="active">
          <a [routerLink]="['/register']" class="feature">
            <span class="text-login-menu">{{ 'HOME.SIGN UP' | translate }}</span>
            <i class="pi pi-user-plus icon-login-menu" aria-hidden="true"></i>
          </a>
        </li>
        <li class="nav__item-button" routerLinkActive="active">
          <a [routerLink]="['/login']" class="feature">
            <span class="text-login-menu">{{ 'HOME.LOGIN' | translate }}</span>
            <i class="pi pi-user icon-login-menu" aria-hidden="true"></i>
          </a>
        </li>
        <li class="nav__item-button" routerLinkActive="active">
          <app-language-selector></app-language-selector>
        </li>
        <li
          class="nav__item-button px-2"
          *ngIf="
            (isLoggedIn$ | async) === false || (isLoggedIn$ | async) === null || (isLoggedIn$ | async) === undefined
          "
        >
          <app-profile-menu></app-profile-menu>
        </li>
      </ul>
    </nav>
  </div>
</div>
